var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../../ts/components/LazyLoader';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.home').length > 0) {
                /* list view toggle */
                $('.project-actions a').on('click', (event, button) => {
                    button.parents('.project-actions').find('a').removeClass('active');
                    button.addClass('active');
                    $('.projects[data-category="' + button.data('category') + '"]').data('mode', button.data('mode'));
                    sessionStorage.setItem('project-list-' + button.data('category') + '-mode', button.data('mode'));
                });
                const projectListArchitectureMode = sessionStorage.getItem('project-list-architecture-mode');
                const projectListTerritoryMode = sessionStorage.getItem('project-list-territory-mode');
                if (projectListArchitectureMode === 'list')
                    $('a[data-category="architecture"][data-mode="list"]').trigger('click');
                if (projectListTerritoryMode === 'list')
                    $('a[data-category="territory"][data-mode="list"]').trigger('click');
                /* mobile behavior */
                $('.page-projects > .row > .col-lg-6').on('click', (event, title) => {
                    if ($(event.target).hasClass('.projects'))
                        event.preventDefault();
                    $('.projects.h-full').removeClass('opened').addClass('closed');
                    $('.page-projects > .row > .col-lg-6').removeClass('active');
                    title.find('.projects.h-full').addClass('opened').removeClass('closed');
                    title.addClass('active');
                    sessionStorage.setItem('project-list-opened-section', title.data('section'));
                    LazyLoader.checkWhile(500);
                });
                const currentSection = sessionStorage.getItem('project-list-opened-section');
                if (currentSection && currentSection != '') {
                    $('.projects.h-full').addClass('no-transition');
                    $('.col-lg-6[data-section="' + currentSection + '"]').trigger('click');
                    setTimeout(() => {
                        $('.projects.h-full').removeClass('no-transition');
                    }, 100);
                }
                else {
                    setTimeout(() => {
                        $('.projects.h-full .row').addClass('appeared');
                    }, 2500);
                }
                /* scroll saver */
                $('.projects.h-full').on('scroll', (event, column) => {
                    const section = column.parents('.col-lg-6').data('section');
                    sessionStorage.setItem('project-list-section-' + section + '-scroll', column.get(0).scrollTop.toString());
                });
                const sectionArchitectureScroll = sessionStorage.getItem('project-list-section-architecture-scroll');
                const sectionTerritoryScroll = sessionStorage.getItem('project-list-section-territory-scroll');
                if (sectionArchitectureScroll)
                    $('.col-lg-6[data-section="architecture"] .projects.h-full').get(0).scrollTo(0, parseInt(sectionArchitectureScroll));
                if (sectionTerritoryScroll)
                    $('.col-lg-6[data-section="territory"] .projects.h-full').get(0).scrollTo(0, parseInt(sectionTerritoryScroll));
                /* section reset */
                $('.home header a').on('click', (event, button) => {
                    sessionStorage.removeItem('project-list-opened-section');
                    sessionStorage.removeItem('project-list-section-architecture-scroll');
                    sessionStorage.removeItem('project-list-section-territory-scroll');
                });
            }
            this.success();
        });
    }
}
